module.exports = __webpack_public_path__ + "img/instagram_icon.6e1449f2.svg";